import XLSX from 'xlsx';
import * as R from 'ramda';
import { columns as BattingColumns } from './FormalGameBoxBatting';
import { columns as PitchingColumns } from './FormalGameBoxPitching';
import { columns as ChanceColumns, toChanceList } from './FormalGameChances';
import { columns as EventColumns, toEventList } from './FormalGameEvents';
import { columns as PAColumns, addSeqList } from './FormalGamePAList';
import { columns as RunnerColumns, toRunnerList } from './FormalGameRunners';
import { columns as SubstitutionColumns, toSubstitutionList } from './FormalGameSubstitutions';
import { getValue } from './common';

export const download = (title, sheets) => {
  const wb = XLSX.utils.book_new();
  wb.Props = {
    Title: title,
    Author: 'Rebas 野革',
    CreatedDate: new Date(),
  };

  const {
    AWAYBattingBox,
    AWAYPitchingBox,
    AWAYPAList,
    AWAYEvents,
    AWAYRunners,
    AWAYChances,
    AWAYSubstitutions,
    HOMEBattingBox,
    HOMEPitchingBox,
    HOMEPAList,
    HOMEEvents,
    HOMERunners,
    HOMEChances,
    HOMESubstitutions,
  } = sheets;

  const sheetNames = [
    {
      name: 'AWAY-BOX-打擊',
      array: AWAYBattingBox,
    },
    {
      name: 'AWAY-BOX-投球',
      array: AWAYPitchingBox,
    },
    {
      name: 'AWAY-打席資訊',
      array: AWAYPAList,
    },
    {
      name: 'AWAY-打席事件',
      array: AWAYEvents,
    },
    {
      name: 'AWAY-跑壘事件',
      array: AWAYRunners,
    },
    {
      name: 'AWAY-防守事件',
      array: AWAYChances,
    },
    {
      name: 'AWAY-換人事件',
      array: AWAYSubstitutions,
    },
    {
      name: 'HOME-BOX-打擊',
      array: HOMEBattingBox,
    },
    {
      name: 'HOME-BOX-投球',
      array: HOMEPitchingBox,
    },
    {
      name: 'HOME-打席資訊',
      array: HOMEPAList,
    },
    {
      name: 'HOME-打席事件',
      array: HOMEEvents,
    },
    {
      name: 'HOME-跑壘事件',
      array: HOMERunners,
    },
    {
      name: 'HOME-防守事件',
      array: HOMEChances,
    },
    {
      name: 'HOME-換人事件',
      array: HOMESubstitutions,
    },
  ];
  sheetNames.forEach((sheetName) => {
    wb.SheetNames.push(sheetName.name);
    const sheet = XLSX.utils.aoa_to_sheet(sheetName.array);
    wb.Sheets[sheetName.name] = sheet;
  });

  XLSX.writeFile(wb, `${title}.xlsx`);
};

export const init = () => {
  const commonPrepend = ['比賽編號', '比賽日期', '球場', '客場', '主場'];
  const AWAYBattingBox = [[...commonPrepend, ...BattingColumns.map((c) => c.label)]];
  const AWAYPitchingBox = [[...commonPrepend, ...PitchingColumns.map((c) => c.label)]];
  const AWAYPAList = [[...commonPrepend, ...PAColumns.map((c) => c.label)]];
  const AWAYEvents = [[...commonPrepend, ...EventColumns.map((c) => c.label)]];
  const AWAYRunners = [[...commonPrepend, ...RunnerColumns.map((c) => c.label)]];
  const AWAYChances = [[...commonPrepend, ...ChanceColumns.map((c) => c.label)]];
  const AWAYSubstitutions = [[...commonPrepend, ...SubstitutionColumns.map((c) => c.label)]];
  const HOMEBattingBox = [[...commonPrepend, ...BattingColumns.map((c) => c.label)]];
  const HOMEPitchingBox = [[...commonPrepend, ...PitchingColumns.map((c) => c.label)]];
  const HOMEPAList = [[...commonPrepend, ...PAColumns.map((c) => c.label)]];
  const HOMEEvents = [[...commonPrepend, ...EventColumns.map((c) => c.label)]];
  const HOMERunners = [[...commonPrepend, ...RunnerColumns.map((c) => c.label)]];
  const HOMEChances = [[...commonPrepend, ...ChanceColumns.map((c) => c.label)]];
  const HOMESubstitutions = [[...commonPrepend, ...SubstitutionColumns.map((c) => c.label)]];

  return {
    AWAYBattingBox,
    AWAYPitchingBox,
    AWAYPAList,
    AWAYEvents,
    AWAYRunners,
    AWAYChances,
    AWAYSubstitutions,
    HOMEBattingBox,
    HOMEPitchingBox,
    HOMEPAList,
    HOMEEvents,
    HOMERunners,
    HOMEChances,
    HOMESubstitutions,
  };
};

export const addGame = (gameWithInPlay, sheets) => {
  const {
    AWAYBattingBox,
    AWAYPitchingBox,
    AWAYPAList,
    AWAYEvents,
    AWAYRunners,
    AWAYChances,
    AWAYSubstitutions,
    HOMEBattingBox,
    HOMEPitchingBox,
    HOMEPAList,
    HOMEEvents,
    HOMERunners,
    HOMEChances,
    HOMESubstitutions,
  } = sheets;

  const commonValues = [
    gameWithInPlay.seq,
    gameWithInPlay.info.started_at,
    gameWithInPlay.info.location,
    gameWithInPlay.away.team,
    gameWithInPlay.home.team,
  ];
  gameWithInPlay.away.box.battings.forEach((batting, battingIndex) => {
    AWAYBattingBox.push([...commonValues, ...BattingColumns.map((c) => getValue(batting, battingIndex, c.column))]);
    return;
  });
  gameWithInPlay.away.box.pitchings.forEach((pitching, pitchingIndex) => {
    AWAYPitchingBox.push([...commonValues, ...PitchingColumns.map((c) => getValue(pitching, pitchingIndex, c.column))]);
    return;
  });
  addSeqList(R.filter((PA) => PA.side === 'AWAY', gameWithInPlay.PA_list)).forEach((PA, PAIndex) => {
    AWAYPAList.push([...commonValues, ...PAColumns.map((c) => getValue(PA, PAIndex, c.column))]);
    return;
  });
  toEventList(R.filter((PA) => PA.side === 'AWAY', gameWithInPlay.PA_list)).forEach((event, eventIndex) => {
    AWAYEvents.push([...commonValues, ...EventColumns.map((c) => getValue(event, eventIndex, c.column))]);
    return;
  });
  toRunnerList(R.filter((PA) => PA.side === 'AWAY', gameWithInPlay.PA_list)).forEach((runner, runnerIndex) => {
    AWAYRunners.push([...commonValues, ...RunnerColumns.map((c) => getValue(runner, runnerIndex, c.column))]);
    return;
  });
  toChanceList(R.filter((PA) => PA.side === 'AWAY', gameWithInPlay.PA_list)).forEach((chance, chanceIndex) => {
    AWAYChances.push([...commonValues, ...ChanceColumns.map((c) => getValue(chance, chanceIndex, c.column))]);
    return;
  });
  toSubstitutionList(R.filter((PA) => PA.side === 'AWAY', gameWithInPlay.PA_list)).forEach((sub, subIndex) => {
    AWAYSubstitutions.push([...commonValues, ...SubstitutionColumns.map((c) => getValue(sub, subIndex, c.column))]);
    return;
  });
  gameWithInPlay.home.box.battings.forEach((batting, battingIndex) => {
    HOMEBattingBox.push([...commonValues, ...BattingColumns.map((c) => getValue(batting, battingIndex, c.column))]);
    return;
  });
  gameWithInPlay.home.box.pitchings.forEach((pitching, pitchingIndex) => {
    HOMEPitchingBox.push([...commonValues, ...PitchingColumns.map((c) => getValue(pitching, pitchingIndex, c.column))]);
    return;
  });
  addSeqList(R.filter((PA) => PA.side === 'HOME', gameWithInPlay.PA_list)).forEach((PA, PAIndex) => {
    HOMEPAList.push([...commonValues, ...PAColumns.map((c) => getValue(PA, PAIndex, c.column))]);
    return;
  });
  toEventList(R.filter((PA) => PA.side === 'HOME', gameWithInPlay.PA_list)).forEach((event, eventIndex) => {
    HOMEEvents.push([...commonValues, ...EventColumns.map((c) => getValue(event, eventIndex, c.column))]);
    return;
  });
  toRunnerList(R.filter((PA) => PA.side === 'HOME', gameWithInPlay.PA_list)).forEach((runner, runnerIndex) => {
    HOMERunners.push([...commonValues, ...RunnerColumns.map((c) => getValue(runner, runnerIndex, c.column))]);
    return;
  });
  toChanceList(R.filter((PA) => PA.side === 'HOME', gameWithInPlay.PA_list)).forEach((chance, chanceIndex) => {
    HOMEChances.push([...commonValues, ...ChanceColumns.map((c) => getValue(chance, chanceIndex, c.column))]);
    return;
  });
  toSubstitutionList(R.filter((PA) => PA.side === 'HOME', gameWithInPlay.PA_list)).forEach((sub, subIndex) => {
    HOMESubstitutions.push([...commonValues, ...SubstitutionColumns.map((c) => getValue(sub, subIndex, c.column))]);
    return;
  });
};
